import React, { Fragment } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { Text } from "components/core/Typography";
import Crumb from "components/search/Breadcrumbs/Crumb";

import "./BreadcrumbList.scss";

const BreadcrumbsList = ({
	breadcrumbs = [],
	allowTruncation = false,
	className,
	variant = "default"
}) => {
	const lastIndexNumber = breadcrumbs.length - 1;

	return (
		<ul className={classNames("breadcrumbs-list", className)}>
			{breadcrumbs.map((crumb, index) => (
				<Fragment key={crumb.label}>
					<li
						className={classNames("breadcrumb-item", {
							"allow-truncation": allowTruncation
						})}
					>
						<Crumb
							label={crumb.label}
							href={crumb.href}
							isLast={index === lastIndexNumber}
							variant={variant}
						/>
						{index !== lastIndexNumber && (
							<Text
								color="lightGray"
								weight="semiBold"
								className="breadcrumb-separator"
							>
								{" "}
								/{" "}
							</Text>
						)}
					</li>
				</Fragment>
			))}
		</ul>
	);
};

BreadcrumbsList.propTypes = {
	breadcrumbs: PropTypes.instanceOf(Array),
	allowTruncation: PropTypes.bool,
	className: PropTypes.string,
	variant: PropTypes.oneOf(["default", "v2"])
};

export default BreadcrumbsList;
